import { __decorate } from "tslib";
import { Options, mixins } from 'vue-class-component';
import Menu from '@/views-cms/menu/Menu.vue';
import { CmsViewModel } from '@/viewmodel/CmsViewModel';
let CmsIndex = class CmsIndex extends mixins(CmsViewModel) {};
CmsIndex = __decorate([Options({
  components: {
    Menu
  }
})], CmsIndex);
export default CmsIndex;